export function paramConvert(params: any) {
  const paramsOutput: any = {};
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        paramsOutput[key] = value;
      }
    });
  }
  return paramsOutput;
}
